// 登录统一相关处理
class LoginInfo {
  constructor() {
    try {
      this.loginInfo = localStorage.getItem('loginInfo') ? JSON.parse(localStorage.getItem('loginInfo')) : {};
    } catch (e) {
      this.loginInfo = {};
      localStorage.removeItem('loginInfo');
    }
    this.userInfo = {};
    this.dingCode = '';
  }

  setDingCode(code = '') {
    this.dingCode = code;
  }

  // 设置corpId
  setCorpId(corpId = '') {
    const loginInfo = this.loginInfo;
    loginInfo.corpId = corpId;
    localStorage.setItem('loginInfo', JSON.stringify(loginInfo));
    console.log(window.location.host, 'window.location.host');
    console.log('设置coroID>>>>>>>');
  }

  // 设置token
  setToken(token = '') {
    const loginInfo = this.loginInfo;
    loginInfo.token = token;
    localStorage.setItem('loginInfo', JSON.stringify(loginInfo));
  }

  // 设置loginInfo内容
  setLogininfo(data) {
    const loginInfo = {
      ...this.loginInfo,
      ...data,
    };
    this.loginInfo = loginInfo;
    console.log('设置loginInfo的信息》》》》》》》》');
    localStorage.setItem('loginInfo', JSON.stringify(loginInfo));
  }

  // 获取loginInfo
  getLoginInfo() {
    return this.loginInfo || JSON.parse(localStorage.getItem('loginInfo') || '{}');
  }

  // 获取token
  getToken() {
    console.log('getToken>>>>>>', this.loginInfo);
    return this.loginInfo.token || JSON.parse(localStorage.getItem('loginInfo') || '{}').token || '';
  }

  // 获取corpId
  getCorpId() {
    return this.loginInfo.corpId || JSON.parse(localStorage.getItem('loginInfo') || '{}').corpId || '';
  }

  // 获取dingUserId
  getDingUserId() {
    return this.userInfo.dingUserId || JSON.parse(localStorage.getItem('userInfo') || '{}').dingUserId || '';
  }

  // 存储用户信息
  serUserInfo(userInfo = {}) {
    this.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  // 获取用户信息
  getUserInfo() {
    return this.userInfo || JSON.parse(localStorage.getItem('userInfo') || '{}');
  }
}

window.$LoginInfo = new LoginInfo();
